import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, TextField, DialogActions, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from './styles.module.css';

export default function AddIpDialog({ handleClose, handleSuccess, selectedPrinterIp }) {
  const { t: tCommon } = useTranslation('common');
  const [data, setData] = useState({
    name: selectedPrinterIp?.name || '',
    ip_address: selectedPrinterIp?.ip_address || '',
  });

  const ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  const isFormValid = data.name.trim() !== '' && ipv4Regex.test(data.ip_address.trim());

  const handleChange = (field) => (e) => {
    setData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleSubmit = () => {
    handleSuccess(data);
    handleClose();
  };

  return (
    <>
      <div className={styles.popUp}>
        <div className={styles.contentWrapper}>
          <div className={styles.headSec}>
            <h2 className={styles.editTitle}>
              {selectedPrinterIp ? tCommon('Edit IP Printer') : tCommon('Add IP Printer')}
            </h2>
            <CloseIcon onClick={handleClose} className={styles.closeBtn} />
          </div>

          <div className={styles.inputSec}>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Name')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={data.name}
                  onChange={handleChange('name')}
                />
              </Grid>
            </Grid>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('IP Address')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={data.ip_address}
                  onChange={handleChange('ip_address')}
                />
              </Grid>
            </Grid>

            <DialogActions>
              <Button variant="contained" color="secondary" size="small" onClick={handleClose}>
                {tCommon('Close')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                style={{ backgroundColor: '#00a65a' }}
                onClick={handleSubmit}
                disabled={!isFormValid}
              >
                {selectedPrinterIp ? tCommon('Update') : tCommon('Add')}
              </Button>
            </DialogActions>
          </div>
        </div>
      </div>
    </>
  );
}
